/**
 * 安全执行异步操作的工具函数
 * @param fn 异步操作
 * @param fallback 失败时的默认值
 * @param errorMsg 错误提示信息
 */
export async function safeAsync(fn, fallback, errorMsg) {
    try {
        return await fn();
    }
    catch (error) {
        if (errorMsg) {
            console.warn(errorMsg, error);
        }
        return fallback;
    }
}
